// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"73":"f5ab5693","174":"61f3a9b5","537":"00bd1f02","575":"d1f49725","785":"71218b88","951":"7d7f48e4"}[chunkId] + ".chunk.css";
};